import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const addToCartButton = node.querySelector('[button-add-to-cart-chatters]');
  const chattersPopup = document.getElementById('chatters-popup');
  const quantityInput = node.querySelector('[data-quantity-input]');
  const quantityIncrease = node.querySelector('[data-quantity-increase]');
  const quantityDecrease = node.querySelector('[data-quantity-decrease]');
  /**
   * Functions
   */
  const increaseQuantity = () => {
    quantityInput.value = Number(quantityInput.value) + 1;
  };
  const decreaseQuantity = () => {
    if (quantityInput.value > 1) {
      quantityInput.value = Number(quantityInput.value) - 1;
    }
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();
    const variantIdToAdd = node.querySelector('[data-variant-id]').dataset.variantId;
    const quantity = quantityInput.value;
    const itemToAdd = [
      {
        id: Number(variantIdToAdd),
        quantity: quantity,
      },
    ];
    await addToCart(itemToAdd);

    const variantTitle = node.querySelector('[data-variant-title]').dataset.variantTitle;
    const variantImage = node.querySelector('[data-variant-image]').dataset.variantImage;

    const chattersPopupImage = chattersPopup.querySelector('[data-chatters-popup-image]');
    const chattersPopupTitle = chattersPopup.querySelector('[data-chatters-popup-title]');

    chattersPopupImage.src = variantImage;
    chattersPopupTitle.innerHTML = variantTitle;

    const popup = document.getElementById('chatters-popup');
    popup.style.right = '20px';

    setTimeout(() => {
      popup.style.right = '-400px';
    }, 3000);
    setTimeout(() => {
      chattersPopupImage.src = '';
      chattersPopupTitle.innerHTML = '';
    }, 5000);

    // remove from body rebuy-cart-visible
    document.body.classList.remove('rebuy-cart-visible');
  };

  // add a mutation observer for the body to detect if the rebuy-cart-visible class is added
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('rebuy-cart-visible')) {
        document.body.classList.remove('rebuy-cart-visible');
      }
    });
  });
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  /**
   * Init
   */
  const init = () => {
    if (addToCartButton) addToCartButton.addEventListener('click', handleAddToCart);

    if (quantityIncrease) quantityIncrease.addEventListener('click', increaseQuantity);
    if (quantityDecrease) quantityDecrease.addEventListener('click', decreaseQuantity);

  };

  init();
};
